export const checkIfEmptyValue = (value) => {
  return value === undefined || value === null || value === "";
};
